import { parseAppConfig } from "./parse-app-config";

export const appConfig = parseAppConfig(process.env.APP_CONFIG);
